<template>
	<div class="my-account">
		<div class="wrapper">
			<div class="header">
				<div class="headerCon">
					<div class="account acea-row row-top row-between">
						<div class="assets">
							<div>购物券(个)</div>
							<div class="money">{{ infoList.integral }}</div>
						</div>
						<!-- <router-link :to="'/user/promotion/usercash'" class="recharge font-color-red">领走</router-link> -->
						<!-- <div class="recharge font-color-red" @click="toCash">领取</div>
						<div class="font-color-red recharge" @click="consign">寄售</div> -->
					</div>
					<div class="activation_popup" v-show="popup">
						<div class="activation_title">烟弹寄售</div>
						<div class="activation_close" @click="close()">
							<img src="@assets/images/close.png" />
						</div>
						<div class="activation_ct">
							<div class="activation_left">数量</div>
							<input type="text" class="activation_pwd" v-model="username" placeholder="请输入寄售数量">
						</div>
						<!-- <div class="bnt bg-color-red margin_t jishou" @click="consigns(username)">寄售</div> -->
					</div>
					<div class="cumulative acea-row row-top">
						<!-- <div class="item">
							<div>钻石(个)</div>
							<div class="money">{{ recharge }}</div>
						</div> -->
						<div class="item">
							<div>余额(USD)</div>
							<div class="money">{{ infoList.now_money }}</div>
						</div>
					</div>
				</div>
				<!-- <div class="recharge tixian font-color-red" @click="withdrawal()">提现</div> -->
			</div>
			<div class="consumpt">
				<div class="title acea-row row-center-wrapper">
					<span class="iconfont icon-zhuangshixian"></span>
					<span class="name">消费记录</span>
					<span class="iconfont icon-zhuangshixian lefticon"></span>
				</div>
				<div class="consumpt_list">
					<div class="consumpt_list_item" v-for="(item,index) in recordList"> <!-- v-for="(item,index) in recordList" -->
						<div class="consumpt_list_left">
							<p class="">{{item.title}}</p>
							<p class="">{{item.add_time | formatDate}}</p>   <!-- {{item.add_time | formatDate}} -->
						</div>
						<div class="consumpt_list_right">{{item.number}}</div>
					</div>
				</div>
			</div>
			<!-- <div class="nav acea-row row-middle">
				<router-link class="item" :to="'/user/bill/0'">
					<div class="pictrue"><img src="@assets/images/record1.png" /></div>
					<div>账单记录</div>
				</router-link>
				<router-link class="item" :to="'/user/bill/1'">
					<div class="pictrue"><img src="@assets/images/record2.png" /></div>
					<div>消费记录</div>
				</router-link>
				<router-link class="item" :to="'/user/bill/2'">
					<div class="pictrue"><img src="@assets/images/record3.png" /></div>
					<div>充值记录</div>
				</router-link>
				<router-link class="item" :to="'/user/integral'">
					<div class="pictrue"><img src="@assets/images/record4.png" /></div>
					<div>积分中心</div>
				</router-link>
			</div> -->
			<!-- <div class="advert acea-row row-between-wrapper">
				<router-link class="item acea-row row-between-wrapper" :to="'/user/sign'">
					<div class="text">
						<div class="name">签到领积分</div>
						<div>赚积分抵现金</div>
					</div>
					<div class="pictrue"><img src="@assets/images/gift.png" /></div>
				</router-link>
				<router-link class="item on acea-row row-between-wrapper" :to="'/user/get_coupon'">
					<div class="text">
						<div class="name">领取优惠券</div>
						<div>满减享优惠</div>
					</div>
					<div class="pictrue"><img src="@assets/images/money.png" /></div>
				</router-link>
			</div> -->
			<!-- 	<div class="list">
				<div class="item acea-row row-between-wrapper">
					<div class="picTxt acea-row row-between-wrapper">
						<div class="iconfont icon-hebingxingzhuang"></div>
						<div class="text">
							<div class="line1">最新拼团活动</div>
							<div class="infor line1">最新的优惠商品上架拼团</div>
						</div>
					</div>
					<router-link class="bnt" :to="'/activity/group'" v-if="activity.is_pink">立即参与</router-link>
					<div class="bnt end" v-else>已结束</div>
				</div>
				<div class="item acea-row row-between-wrapper">
					<div class="picTxt acea-row row-between-wrapper">
						<div class="iconfont icon-miaosha yellow"></div>
						<div class="text">
							<div class="line1">当前限时秒杀</div>
							<div class="infor line1">最新商品秒杀进行中</div>
						</div>
					</div>
					<router-link class="bnt" :to="'/activity/goods_seckill'" v-if="activity.is_seckill">立即参与</router-link>
					<div class="bnt end" v-else>已结束</div>
				</div>
				<div class="item acea-row row-between-wrapper">
					<div class="picTxt acea-row row-between-wrapper">
						<div class="iconfont icon-kanjia1 green"></div>
						<div class="text">
							<div class="line1">砍价活动</div>
							<div class="infor line1">呼朋唤友来砍价</div>
						</div>
					</div>
					<router-link class="bnt" :to="'/activity/bargain'" v-if="activity.is_bargin">立即参与</router-link>
					<div class="bnt end" v-else>已结束</div>
				</div>
			</div> -->
		</div>
		<!-- <Recommend></Recommend> -->
	</div>
</template>
<script>
	import Recommend from "@components/Recommend";
	import { getActivityStatus, getUserInfo, getConsigns,getRecord} from "@api/user";
	export default {
		name: "UserAccount",
		components: {
			Recommend
		},
		props: {},
		data: function() {
			return {
				now_money: 0,
				orderStatusSum: 0,
				recharge: 0,
				activity: {
					is_bargin: false,
					is_pink: false,
					is_seckill: false
				},
				username: '',
				popup: 0,
				recordList:'',
				infoList:'',
			};
		},
		mounted: function() {
			this.getIndex();
			this.getActivity();
			this.consignRecord();
		},
		filters: {
			formatDate: function(value) {
				var date = new Date(value * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
				var Y = date.getFullYear() + '-';
				var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
				var D = date.getDate() + ' ';
				var h = date.getHours() + ':';
				var m = date.getMinutes() + ':';
				var s = date.getSeconds();
				return Y + M + D + h + m + s;
				console.log(Y + M + D + h + m + s)
			}
		},
		methods: {
			// 关闭寄售弹窗
			close:function(){
				this.popup = 0;
			},
			// 余额去提现
			withdrawal:function(){
				console.log(1111111111)
				this.$router.push({
					path:'/user/user_promotion'
				})
			},
			consignRecord:function(){
				getRecord()
				.then((res) => {
					console.log(res.data)
					this.recordList = res.data
				})
				.catch((res) => {
					
				})
			},
			consign: function() {
				this.popup = 1
			},
			// 寄售
			consigns: function(username) {
				if (username == '' || username == undefined) {
					this.$dialog.toast({
						mes: '请输入寄售数量'
					});
					this.popup = 0
				} else {
					getConsigns(username)
						.then((res) => {
							this.$dialog.toast({
								mes: res.msg
							});
							this.popup = 0
						})
						.catch((res) => {
							this.$dialog.toast({
								mes: res.msg
							});
							this.popup = 0
						})
				}
			},
			// 领走
			toCash: function() {
				this.$router.push({
					path: "/user/OrderAddress"
				});
			},
			getIndex: function() {
				let that = this;
				getUserInfo().then(
					res => {
						console.log()
						that.infoList = res.data
						// that.now_money = res.data.now_money;
						// that.orderStatusSum = res.data.price;
						// that.recharge = res.data.integral;
					},
					err => {
						that.$dialog.message(err.msg);
					}
				);
			},
			getActivity: function() {
				let that = this;
				getActivityStatus().then(
					res => {
						that.activity.is_bargin = res.data.is_bargin;
						that.activity.is_pink = res.data.is_pink;
						that.activity.is_seckill = res.data.is_seckill;
					},
					error => {
						that.$dialog.message(error.msg);
					}
				);
			}
		}
	};
</script>
<style>
	.consumpt{
		width: 100%;
	}
	.activation_close{
		position: absolute;
		right: 4%;
		top: 4%;
		width: 25px;
		height: 25px;
		display: block;
	}
	.activation_close img{
		width: 100%;
		display: block;
	}
	.acea-row.row-center-wrapper{
		margin-top: 0.3rem;
	}
	.title .iconfont{
		font-size: 1.7rem;
		color: #454545;
		height: 0.5rem;
		line-height: 0.5rem;
	}
	.tixian{
		font-size: 0.28rem;
		color: #fff!important;
		width: 2.58rem;
		height: 0.68rem;
		border-radius: 0.5rem;
		text-align: center;
		line-height: 0.68rem;
		background-color: #fc4141 !important;
		margin: 3% auto;
		/* margin: -0.32rem auto 0 auto; */
	}
	.lefticon{
		transform: rotate(180deg);
		-webkit-transform: rotate(180deg);
		-ms-transform: rotate(180deg);
		-moz-transform: rotate(180deg);
		-o-transform: rotate(180deg);
	}
	
	.consumpt_list{
		margin-top: 20px;
		border-top: 1px dashed #eee;
	}
	.consumpt_list_item{
		width: 100%;
		display: flex;
		padding: 10px 0px;
		border-bottom: 1px solid #eee;
	}
	.consumpt_list_left{
		width: 70%;
	}
	.consumpt_list_left p{
		padding-left: 8%;
		line-height: 23px;
	}
	.consumpt_list_left p:first-child{
		font-size: 0.3rem;
		color: #232323;
	}
	.consumpt_list_left p:last-child{
		font-size: 0.24rem;
		color: #BBBBBB;
	}
	.consumpt_list_right{
		width: 30%;
		display: flex;
		text-align: center;
		align-items: center;
		vertical-align: middle;
		justify-content: center;
	}
	.activation_popup {
		position: fixed;
		left: 10%;
		top: 20%;
		width: 80%;
		background-color: rgba(0, 0, 0, 0.8);
		border-radius: 10px;
		padding: 10px 12px;
	}

	.activation_ct {
		width: 100%;
		padding-left: 20px;
	}

	.jishou {
		font-size: 0.28rem;
		color: #fff;
		width: 2.58rem;
		height: 0.68rem;
		border-radius: 0.5rem;
		text-align: center;
		line-height: 0.68rem;
		margin: 0.3rem auto 0 auto;
	}

	.activation_left {
		font-size: 14px;
		color: #FFFFFF;
		height: 35px;
		line-height: 35px;
	}

	.activation_ct input {
		width: 100%;
		height: 35px;
		color: #FFF3F3;
	}

	.activation_title{
		width: 100%;
		height: 40px;
		font-size: 18px;
		line-height: 40px;
		text-align: center;
		color: #FFFFFF;
	}
</style>

